import styled from 'styled-components';
import { getColorShade } from '../../../../../src/styled/utils';
export const CellPlaceholder = styled.span `
  height: 16px;
  color: transparent;
  background-color: ${getColorShade('onSurface', 'hover')};
  border-radius: 3px;
`;
